import { Outlet } from "react-router-dom";
import ErrorBoundary from "../api/ErrorBoundary";
import SeoLoader from "../components/seo/SeoLoader";
import UploadNav from "../components/navbar/navbarComponents/UploadNav";
import UploadNavMob from "../components/uploadMobileNav/UploadNavMob";

const UploadLayout = () => {
  return (
    <div className="upload-layout">
      <ErrorBoundary>
        <SeoLoader />
        <UploadNav />
        <Outlet />
        <UploadNavMob />
      </ErrorBoundary>
    </div>
  );
};

export default UploadLayout;
